import { render } from "./confirmaterms.vue?vue&type=template&id=26c6b3de"
import script from "./confirmaterms.vue?vue&type=script&lang=js"
export * from "./confirmaterms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__